export const SECTION_INTERNAL_PADDING = 20;
